import { namespaces } from '@common'

export const namespace = namespaces.card.value
export const schema = 'cardSchema'
export const backendDocType = 'Card'
export const docPrivilege = 'card.card'
